import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "箭头_向右",
  "use": "箭头_向右-usage",
  "viewBox": "0 0 18.02 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.02 12\" id=\"箭头_向右\"><defs><style>#箭头_向右 .cls-1{fill:#a6a3d6;}</style></defs><g id=\"箭头_向右_页面-1\"><g id=\"箭头_向右_用例知识库-模版中心\"><g id=\"箭头_向右_编组-22\"><g id=\"箭头_向右_编组-17\"><g id=\"箭头_向右_编组-14\"><g id=\"箭头_向右_箭头_向右\" data-name=\"箭头 向右\"><polygon id=\"箭头_向右_路径\" class=\"cls-1\" points=\"14.38 5.11 0 5.11 0 6.89 14.38 6.89 11 12 18.02 6 11.11 0 14.38 5.11\" /></g></g></g></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol